import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _toConsumableArray from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _half;

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\t", ";\n\toverflow: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t", ";\n\n\trow-gap: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: grid;\n\tmax-width: ", "px;\n\tmargin: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\t", "\n\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { Breakpoints } from '../helpers';
import { DesignTokenSizeEnum, css, styled } from '../theme-provider';
export { DesignTokenSizeEnum as LayoutRowGap };
export var LayoutConfigurations = {
  full: _defineProperty({}, Breakpoints.default, [{
    name: 'a',
    columns: 24
  }]),
  half: (_half = {}, _defineProperty(_half, Breakpoints.default, [{
    name: 'a',
    columns: 24
  }, {
    name: 'b',
    columns: 24
  }]), _defineProperty(_half, Breakpoints.tablet, [{
    name: 'a',
    columns: 12
  }, {
    name: 'b',
    columns: 12
  }]), _half)
};

var areaConfigIsPlaceholder = function areaConfigIsPlaceholder(areaConfig) {
  return areaConfig.name !== '.';
}; // increase the number of areas in a configuration so it has at least [length] areas


export var createFullLayoutConfiguration = function createFullLayoutConfiguration(config, length) {
  var configWithoutEmptySpaces = config.filter(areaConfigIsPlaceholder);
  return Array.from({
    length: Math.ceil(length / configWithoutEmptySpaces.length) * config.length
  }, function (_ignore, index) {
    var name = config[index % config.length].name;
    var columns = config[index % config.length].columns;

    if (name === '.') {
      return {
        name: name,
        columns: columns
      };
    }

    return {
      name: "".concat(name).concat(Math.floor(index / config.length)),
      columns: columns
    };
  });
}; // distribute configured areas into lines and resolve column numbers

export var createLayoutConfigurationLines = function createLayoutConfigurationLines(config) {
  return config.reduce(function (acc, area) {
    var newAreas = new Array(area.columns).fill(area.name);

    if (!acc.length || acc[acc.length - 1].length + area.columns > 24) {
      acc.push(newAreas);
    } else {
      var _acc;

      (_acc = acc[acc.length - 1]).push.apply(_acc, _toConsumableArray(newAreas));
    }

    return acc;
  }, []);
};

var getGridTemplateColumns = function getGridTemplateColumns(props) {
  var appearance = props.appearance,
      children = props.children;
  return css(_templateObject(), Object.keys(appearance).map(function (breakpoint) {
    var config = appearance[breakpoint];
    var length = React.Children.count(children);
    var fullConfig = createFullLayoutConfiguration(config, length);
    var configLines = createLayoutConfigurationLines(fullConfig);
    var rule = "\n\t\t\t\t\tgrid-template-columns: repeat(24, 1fr);\n\t\t\t\t\tgrid-template-areas: ".concat(configLines.map(function (line) {
      return "\"".concat(line.join(' '), "\"");
    }).join(' '), ";\n\t\t\t\t");

    if (parseInt(breakpoint, 10) === Breakpoints.default) {
      return rule;
    }

    return "\n\t\t\t\t@media (min-width: ".concat(breakpoint, "px) {\n\t\t\t\t\t").concat(rule, "\n\t\t\t\t}\n\t\t\t");
  }));
};

var StyledBaseContainer = styled.div.withConfig({
  displayName: "StyledBaseContainer",
  componentId: "sc-s648rg"
})(_templateObject2(), Breakpoints.b2560);
var StyledContainer = styled(StyledBaseContainer).withConfig({
  displayName: "StyledContainer",
  componentId: "sc-flfppu"
})(_templateObject3(), function (props) {
  return getGridTemplateColumns(props);
}, function (props) {
  return props.rowGap && "".concat(props.theme.size[props.rowGap]);
});
StyledContainer.displayName = 'StyledContainer';

var getGridAreaForConfigAndChild = function getGridAreaForConfigAndChild(config, index) {
  return Object.keys(config).map(function (breakpoint) {
    var configForBreakpoint = config[breakpoint].filter(areaConfigIsPlaceholder);
    var configForDefaultBreakpoint = config[Breakpoints.default].filter(areaConfigIsPlaceholder);
    var rule = "grid-area: ".concat(configForDefaultBreakpoint[index % configForBreakpoint.length].name).concat(Math.floor(index / configForBreakpoint.length), ";");

    if (parseInt(breakpoint, 10) === Breakpoints.default) {
      return rule;
    }

    return "\n\t\t\t@media (min-width: ".concat(breakpoint, "px) {\n\t\t\t\t").concat(rule, "\n\t\t\t}\n\t\t");
  });
};

var StyledChildWrapper = styled.div.withConfig({
  displayName: "StyledChildWrapper",
  componentId: "sc-ebnt2j"
})(_templateObject4(), function (props) {
  var appearance = props.appearance,
      _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index;
  return getGridAreaForConfigAndChild(appearance, index);
}, function (props) {
  return props.allowOverflowingContent ? 'visible' : 'hidden';
});
StyledChildWrapper.displayName = 'StyledChildWrapper';
export var Layout = function Layout(props) {
  var children = props.children,
      rowGap = props.rowGap,
      allowOverflowingContent = props.allowOverflowingContent,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? LayoutConfigurations.full : _props$appearance;
  var filteredChildren = React.Children.toArray(children).filter(React.isValidElement);

  if (filteredChildren.length === 0) {
    return null;
  }

  var wrappedChildren = filteredChildren.map(function (child, index) {
    var key = child.key === null ? undefined : child.key;
    return React.createElement(StyledChildWrapper, {
      appearance: appearance,
      key: key,
      index: index,
      allowOverflowingContent: allowOverflowingContent
    }, child);
  });
  return React.createElement(StyledContainer, {
    appearance: appearance,
    rowGap: rowGap
  }, wrappedChildren);
};
Layout.displayName = 'Layout';